import React, { Component } from 'react';

import './NoRedirectExist.css';

class NoRedirectExist extends Component {
  
  static defaultProps = {
    toggleRedirectModal : () => {
      console.error("toggleRedirectModal not deliveried to NoRedirectExist ");
    }
  }

  NoRedirectExistMessage = "리다이렉트가 없습니다.";

  render() {

    const { NoRedirectExistMessage } = this;
    const { toggleRedirectModal } = this.props;

    return (
      <div class="no-redirect-exist">
        <span class="no-redirect-text">
          <span class="text">
            {NoRedirectExistMessage}
          </span>
        </span> 
        <div class="right-options">
          <button class="create-redirect-btn" onClick={toggleRedirectModal} > 생성 </button>
        </div>
      </div>
    );
  }
}

export default NoRedirectExist;